import React from "react";
import { IAddLanguage, ILanguageId } from "../../Language.props";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton";
import Loader from "../../../../components/Loader";
import useAddLanguage from "./useAddLanguage";

const AddLanguage: React.FC = () => {
  const { formData, loading, handleChange, handleSubmit, handleCancel } =
    useAddLanguage();
  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
  } = useForm<IAddLanguage>();

  const fields = [
    { label: "Edu. Language", name: "languageName", type: "text" },
    { label: "Edu. Language Code", name: "languageCode", type: "text" },
  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Add Edu. Language</h1>
        </div>
        {loading && <Loader />}
        <form onSubmit={useFormSubmit(handleSubmit)} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {fields.map((field) => (
                <div key={field.name}>
                  <label
                    className="block text-gray-700 text-base font-semibold mb-2"
                    htmlFor={field.name}
                  >
                    {field.label}:
                  </label>
                  <input
                    className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                    type={field.type}
                    id={field.name}
                    {...register(field.name, { required: false })}
                    value={formData[field.name]}
                    onChange={handleChange}
                  />
                  {formData[field.name] === "" && (
                    <span className="text-red-500 text-xs italic">
                      {field.label} field is required
                    </span>
                  )}
                </div>
              ))}
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton
              className="py-2 px-4 rounded mr-4"
              type="submit"
              children="ADD"
            />
            <CancelButton
              className="py-2 px-4 rounded"
              onClick={handleCancel}
              children="Cancel"
              type="button"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLanguage;
